import classNames from 'classnames';
import isArray from 'lodash/isArray';
import { useMemo } from 'react';

import { addIcons as addSocialIcons } from '../icons/socialIcons';
import ColumnsMenu from '../menus/Columns';
import AddBox from './AddBox';
import NewArticle from './NewArticle';
import Newsletter from './Newsletter';

import styles from '../../../styles/partials/footer.module.css';

interface MenuColumn {
    items: unknown[];
    [key: string]: unknown;
}

interface FooterProps {
    menuColumns: MenuColumn[];
    splashIsGrey?: boolean;
    splashIsWhite?: boolean;
    newsletterIsLarge?: boolean;
}

function Footer({
    menuColumns,
    splashIsGrey = false,
    splashIsWhite = false,
    newsletterIsLarge = false,
}: FooterProps) {
    const menuColumnsCount = menuColumns.length;
    const finalColumns = useMemo(
        () =>
            menuColumns.map((col, index) =>
                index === menuColumnsCount - 1
                    ? {
                          ...col,
                          items: col.items.map((it) =>
                              isArray(it)
                                  ? addSocialIcons(it, {
                                        white: true,
                                        className: styles.icon,
                                    })
                                  : it,
                          ),
                      }
                    : col,
            ),
        [menuColumns, menuColumnsCount],
    );

    return (
        <div className={styles.container}>
            <div
                className={classNames([
                    styles.splash,
                    {
                        [styles.isGrey]: splashIsGrey,
                        [styles.isWhite]: splashIsWhite,
                    },
                ])}
            >
                <div className={styles.wrapper}>
                    <div className={styles.middle}>
                        <div className={classNames(['page-inner', styles.inner])}>
                            <div className={styles.cols}>
                                <div className={classNames([styles.col, styles.colNewsletter])}>
                                    <Newsletter
                                        className={styles.newsletter}
                                        large={newsletterIsLarge}
                                    />
                                </div>
                                <div className={classNames([styles.col, styles.colNewArticle])}>
                                    <div className={styles.new}>
                                        <NewArticle className={styles.newArticle} />
                                    </div>
                                    <div className={styles.addBox}>
                                        <AddBox />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.backgroundColor} />
            </div>
            <div className={styles.menu}>
                <div className={classNames(['page-inner', styles.inner])}>
                    <ColumnsMenu
                        columns={finalColumns}
                        titleClassName={styles.title}
                        colsClassName={styles.cols}
                        colClassName={styles.col}
                        subItemsClassName={styles.socialIcons}
                        itemClassName={styles.item}
                        linkClassName={styles.link}
                    />
                </div>
            </div>
        </div>
    );
}

export default Footer;
